import React from 'react';
import { Page, Navbar } from 'framework7-react';
import { CSSTransition } from 'react-transition-group';

const random = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const compare = (a, b) => {
  a = a.toLowerCase();
  b = b.toLowerCase();
  a = a.replace(/[^a-zäöüß]+/g, '');
  b = b.replace(/[^a-zäöüß]+/g, '');
  console.log(a);
  console.log(b);
  
  if (a.length === 0)
      return b.length;
  if (b.length === 0)
      return a.length;

  var matrix = [];

  // increment along the first column of each row
  var i;
  for ( i = 0; i <= b.length; i++) {
      matrix[i] = [i];
  }

  // increment each column in the first row
  var j;
  for ( j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
  }

  // Fill in the rest of the matrix
  for ( i = 1; i <= b.length; i++) {
      for ( j = 1; j <= a.length; j++) {
          if (b.charAt(i - 1) === a.charAt(j - 1)) {
              matrix[i][j] = matrix[i-1][j - 1];
          } else {
              matrix[i][j] = Math.min(matrix[i-1][j - 1] + 1, // substitution
              Math.min(matrix[i][j - 1] + 1, // insertion
              matrix[i-1][j] + 1)); // deletion
          }
      }
  }
  var distance = matrix[b.length][a.length];
  console.log('Levenshtein-Distanz beträgt ' + distance);
  var deviation = Math.floor((distance / b.length) * 100);
  console.log('Abweichung beträgt ' + deviation + '%');
  var similarity = 100 - deviation;
  console.log('Übereinstimmung beträgt ' + similarity + '%');
  return similarity;
}

class Guess extends React.Component {
  state = {
    line: null,
    followingLine: null,
    solved: false,
    songName: null,
    enteredText: '',
    similarity: null,
  }

  songs = null

  input = null

  componentDidMount = () => {
    return fetch('lyrics/' + this.$f7route.context.artist.id + '.json')
      .then((response) => response.json())
      .then((responseJson) => {
        this.songs = responseJson.songs;
        this.initialize();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  getLines = () => {
    const songNo = random(0, this.songs.length - 1);
    console.log('Song: ' + this.songs[songNo].song + ' (' + (songNo + 1) + ' von ' + this.songs.length + ')');
    let partNo;
    do {
        partNo = random(0, this.songs[songNo].lyrics.length - 1);
    } while (this.songs[songNo].lyrics[partNo].length < 2);
    console.log('Part: ' + (partNo + 1) + ' von ' + this.songs[songNo].lyrics.length);
    let lineNo = random(0, Math.floor((this.songs[songNo].lyrics[partNo].length - 1) / 2)) * 2;
    if (lineNo + 1 > this.songs[songNo].lyrics[partNo].length - 1) {
        lineNo--;
    }
    console.log('Line: ' + (lineNo + 1) + ' von ' + this.songs[songNo].lyrics[partNo].length);
    
    return {
      line: this.songs[songNo].lyrics[partNo][lineNo],
      followingLine: this.songs[songNo].lyrics[partNo][lineNo + 1],
      songName: this.songs[songNo].song 
    }
  }

  initialize = () => this.setState({...this.getLines(), solved: false, enteredText: ''});

  initializeAndFocus = () => {this.initialize(); this.input.focus()};

  check = () => {
    if (this.state.enteredText.trim() === '') {
      this.setState({nothingEntered: true});
    } else {
      this.setState({similarity: compare(this.state.followingLine, this.state.enteredText.trim()), solved: true})
    }
  };

  render = () => {
    return (
      <Page
        name="guess"
        onPageAfterIn={() => this.input.focus()}
      >
        <Navbar
          title={this.$f7route.context.artist.name}
          backLink="Zurück"
        />
        {!this.state.line ?
        <div className="loading-indicator">Lädt...</div> :
        <div className="line-container">
          <div className="line">{this.state.line}</div>            
          <CSSTransition
            in={this.state.solved}
            timeout={300}
            exit={false}
            classNames="smoothSlide"
            unmountOnExit
          >
            <div className="solved-container">
              <div className="following-line">{this.state.followingLine}</div>
              <div className="citation">aus <span className="bold-text">{this.state.songName}</span></div>
            </div>
          </CSSTransition>
        </div>}
        <div className="input-button-combo">
          <input
            className="input round"
            ref={(input) => { this.input = input; }} 
            value={this.state.enteredText}
            onChange={(event) => this.setState({enteredText: event.currentTarget.value, nothingEntered: false})}
            onKeyPress={!this.state.solved ? (event) => {if (event.which === 13) {this.check();}} : (event) => {if (event.which === 13) {this.initialize();}}}
          />
          {!this.state.solved ?
          <button className="check-button round" onClick={this.check}>Prüfen</button> :
          <button className="check-button round" onClick={this.initializeAndFocus}>Nächste Line</button>}
        </div>
        <CSSTransition
          in={this.state.nothingEntered || this.state.solved}
          timeout={300}
          exit={false}
          classNames="smoothSlide"
          unmountOnExit
        >
          <div className={'evaluation round ' + (this.state.nothingEntered ? 'yellow' : ((this.state.similarity >= 45) ? 'green' : 'red'))}>
            {this.state.nothingEntered ? 'Das Textfeld ist leer...' : <span>{(this.state.similarity >= 45) ? 'Korrekt' : 'Falsch'}! Die Übereinstimmung beträgt <span className="bold-text">{this.state.similarity}%</span>!</span>}
          </div>
        </CSSTransition>
      </Page>
    )
  }
}

export default Guess;


// WEBPACK FOOTER //
// ./src/guess.js